import { render, staticRenderFns } from "./objBarcodeSelected.vue?vue&type=template&id=6a077fb0&"
import script from "./objBarcodeSelected.vue?vue&type=script&lang=ts&"
export * from "./objBarcodeSelected.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports